import { SOURCE_LANGUAGE, SOURCE_LANGUAGE_ENTRY } from '../constants/languages';

/**
 * Turns the backend's language list into the entries the app uses.
 *   backend: { code, name, native_name, direction }
 *   app    : { code, label, englishName, dir }
 */

// "ar", "pt", "zh-CN" ... lower-case language code, optional region/script parts.
const CODE_PATTERN = /^[a-z]{2,3}(-[A-Za-z0-9]{2,8})*$/;

export const isValidLanguageCode = (code) => typeof code === 'string' && CODE_PATTERN.test(code);

export const normalizeRemoteLanguage = (raw) => {
    if (!raw || !isValidLanguageCode(raw.code)) return null;
    const englishName = (typeof raw.name === 'string' && raw.name.trim()) || raw.code;
    const nativeName = typeof raw.native_name === 'string' ? raw.native_name.trim() : '';
    return {
        code: raw.code,
        label: nativeName || englishName,
        englishName,
        dir: raw.direction === 'rtl' ? 'rtl' : 'ltr',
    };
};

/** English first, then the backend's languages in their given order (invalid/duplicates dropped). */
export const buildLanguageList = (remoteLanguages = []) => {
    const seen = new Set([SOURCE_LANGUAGE]);
    const list = [SOURCE_LANGUAGE_ENTRY];
    remoteLanguages.forEach((raw) => {
        const language = normalizeRemoteLanguage(raw);
        if (!language || seen.has(language.code)) return;
        seen.add(language.code);
        list.push(language);
    });
    return list;
};

export const findLanguage = (languages, code) =>
    languages.find((language) => language.code === code) || null;
